import { Action, Reducer } from 'redux';
import { FinanceAction } from './actions';
import { RestaurantFinance } from 'api/models';
import { createRestaurantFinanceSales, createRestaurantPaymentReport } from './factories';
import { RestaurantPaymentReport } from './interfaces';

// export interface FinanceDishData {
//     amount: number;
//     name: string;
//     number: number;
//     price: number;
// }
// export interface FinanceServicesData {
//     dishes: FinanceDishData[];
//     name: string;
//     totalAmount: number;
//     cancelledDishes: FinanceDishData[];
// }

// export interface FinanceData {
//     amount: number;
//     name: string;
//     services: FinanceServicesData[];
// }

// export interface FinanceOrderData {
//     id: string;
//     createDate: string;
//     service: string;
//     cancelled?: boolean;
//     totalAmount: number;
// }

export interface FinanceState {
    financeSales: RestaurantFinance;
    paymentReport: RestaurantPaymentReport;
}

const initialState: FinanceState = {
    financeSales: createRestaurantFinanceSales(),
    paymentReport: createRestaurantPaymentReport(),
};

export const reducer: Reducer<FinanceState> = (
    state: FinanceState | undefined,
    incomingAction: Action
): FinanceState => {
    if (state === undefined) {
        return initialState;
    }

    const action = incomingAction as FinanceAction;
    switch (action.type) {
        case 'GET_FINANCE_DETAILS_SUCCESS': {
            return {
                ...state,
                financeSales: action.payload,
            };
        }
        case 'GET_PAYMENT_REPORT_SUCCESS': {
            return {
                ...state,
                paymentReport: createRestaurantPaymentReport(action.payload)
            };
        }
        default:
            return state;
    }
};
